/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, metres: NonNullable<unknown> }} Workout_Quick_Dose_DistanceInputs */

const en_us2_workout_quick_dose_distance = /** @type {(inputs: Workout_Quick_Dose_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.metres} m`)
};

const pt_br2_workout_quick_dose_distance = /** @type {(inputs: Workout_Quick_Dose_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.metres} m`)
};

const es_419_workout_quick_dose_distance = /** @type {(inputs: Workout_Quick_Dose_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.metres} m`)
};

const pt_pt2_workout_quick_dose_distance = /** @type {(inputs: Workout_Quick_Dose_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.metres} m`)
};

const fr_fr2_workout_quick_dose_distance = /** @type {(inputs: Workout_Quick_Dose_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.metres} m`)
};

const de_de2_workout_quick_dose_distance = /** @type {(inputs: Workout_Quick_Dose_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.metres} m`)
};

const it_it2_workout_quick_dose_distance = /** @type {(inputs: Workout_Quick_Dose_DistanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.metres} m`)
};

/**
* | output |
* | --- |
* | "{sets} × {metres} m" |
*
* @param {Workout_Quick_Dose_DistanceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_dose_distance = /** @type {((inputs: Workout_Quick_Dose_DistanceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Dose_DistanceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_dose_distance(inputs)
	if (locale === "es-419") return es_419_workout_quick_dose_distance(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_dose_distance(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_dose_distance(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_dose_distance(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_dose_distance(inputs)
	return en_us2_workout_quick_dose_distance(inputs)
});
export { workout_quick_dose_distance as "workout-quick.dose_distance" }